import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import PropTypes from "prop-types";

export function SolidGauge({
  value,
  max = 100,
  label,
  color = "#34d399",
  trackColor = "rgba(45,212,191,0.12)",
  height = 220,
}) {
  const pct = max > 0 ? Math.round((value / max) * 100) : 0;
  const data = [
    { name: "value", value: pct },
    { name: "track", value: 100 - pct },
  ];

  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          startAngle={200}
          endAngle={-20}
          innerRadius="42%"
          outerRadius="88%"
          paddingAngle={0}
          dataKey="value"
          stroke="none"
          cornerRadius={8}
          animationDuration={1200}
          animationEasing="ease-out"
        >
          <Cell fill={color} />
          <Cell fill={trackColor} />
        </Pie>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontSize: "1.5rem", fontWeight: 800, fill: color }}
        >
          {pct}%
        </text>
        {label && (
          <text
            x="50%"
            y="66%"
            textAnchor="middle"
            dominantBaseline="middle"
            style={{ fontSize: "0.65rem", fontWeight: 500, fill: "#64748b" }}
          >
            {label}
          </text>
        )}
      </PieChart>
    </ResponsiveContainer>
  );
}

SolidGauge.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number,
  label: PropTypes.string,
  color: PropTypes.string,
  trackColor: PropTypes.string,
  height: PropTypes.number,
};

export default SolidGauge;
